import type { AnalyticsEvent } from "@decocms/apps-commerce/types";

/**
 * Pushes straight to `window.dataLayer` (GA4/GTM ecommerce contract: clear
 * `ecommerce` before each push so old item data doesn't leak into the next
 * event via dataLayer's shallow merge). GTM-N7CX5NT's Meta Pixel/GA4 tags
 * key off exactly this shape.
 *
 * `event_id`: a fresh id per event, sibling to `ecommerce` so it never
 * touches the GA4-typed `AnalyticsEvent["params"]` contract. The GTM Meta
 * Pixel tags pass it as `eventID` (container version 166), and
 * `~/sdk/metaCapi` sends the same id server-side for view_item/add_to_cart,
 * so Events Manager deduplicates browser vs server instead of
 * double-counting.
 *
 * Previously routed through a `globalThis.DECO_SITES_STD.sendAnalyticsEvent`
 * indirection that nothing ever defined — every call silently no-op'd.
 */
export const sendEvent = <E extends AnalyticsEvent>(event: E) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];

  if (event.name === "deco") {
    window.dataLayer.push({ event: event.name, deco: event.params });
    return;
  }

  // Barramento do DecoRootLayout: é daqui que o módulo `deco` do Deco Analytics
  // lê os eventos de commerce. Nada mais assina, então não duplica no GTM.
  const bus = window.DECO?.events as unknown as { dispatch?(event: unknown): void } | undefined;
  bus?.dispatch?.(event);

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: event.name,
    event_id: crypto.randomUUID(),
    ecommerce: event.params,
  });
};

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
